<template>
  <div class="productItem">
    <router-link class="productLink linkBlock" :to="routerLink(item.id)">
      <div class="productType" v-if="$route.name === 'checkout'">
        {{ $t('NAV_MERCHANDISE') }}
      </div>
      <div class="imageContainer">
        <ImageC v-if="item.images[0]" :srcSuffix="`${item.images[0]}`" @load="imageLoaded"></ImageC>
        <!--img v-if="item.images[0]"
:src="`${publicURL}420/${item.images[0]}`" @load="imageLoaded" -->
      </div>
      <div class="text">
        <div class="titleAndCategory">
          <div class="title">
            <div class="price priceInline">
              {{ formatCurrency(item.price) }}
            </div>
            {{ item.name }}
          </div>
          <div class="soldout" v-if="parseInt(item.stock, 10) <= 0">
            {{ $t('MERCHANDISE_SOLDOUT') }}
          </div>
          <div class="categories">
            <span v-for="category in item.custom_groups" :key="category.id">{{
              category.name
            }}</span>
          </div>
          <div class="description">{{ item.description_short }}</div>
        </div>
        <div class="price priceBelow">{{ formatCurrency(item.price) }}</div>
      </div>
      <div class="checkoutActions" v-if="$route.name === 'checkout'">
        <button @click.stop.prevent="addToCart(item.id, 1)">
          {{ $t('CHECKOUT_ADD_PRODUCT') }}
        </button>
        <button @click="$router.push(routerLink(item.id))">
          {{ $t('CHECKOUT_MORE_INFO') }}
        </button>
      </div>
    </router-link>
  </div>
</template>

<script>
import ImageC from '../ImageC.vue'
import formater from '../../lib/formater'

export default {
  name: 'ProductListItem',
  components: { ImageC },
  props: {
    item: { required: true }
  },
  methods: {
    addToCart(id, quantity) {
      this.$store.dispatch('products/setQuantity', quantity)
      this.$store.dispatch('products/addToCart', { id, product: this.item }).then(() => {
        this.$toasted.show(this.$t('MERCHANDISE_ADDED_TO_CART')).goAway(2000)
        this.$router.push({ name: 'checkout' })
      })
    },
    formatCurrency(val) {
      return formater.currency(val)
    },
    routerLink(id) {
      if (this.$route.name === 'passes') {
        return { name: 'pass', params: { id: id } }
      }
      return { name: 'product', params: { id: id } }
    },
    imageLoaded(e) {
      if (e.height > this.maxImageHeight) {
        this.maxImageHeight = e.height
      }
      e.classList.add('loaded')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/grid';
@import '../../scss/mixins';
@import '../../scss/scaffolding'; // img-responsive

.productItem > a {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  color: $text-color;
  text-decoration: none;
}

.productItem > a {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  color: $text-color;
  text-decoration: none;
}
.productItem {
  width: calc(100% / 4);
  padding-left: $sp;
  padding-right: $sp;
  display: flex;
  vertical-align: top;
  margin-bottom: $sp * 3;

  @media screen and (max-width: $screen-lg) {
    width: calc(100% / 3);
  }

  @media screen and (max-width: $screen-md) {
    width: calc(100% / 2);
  }
  @media screen and (max-width: $screen-sm) {
    width: calc(100% / 2);
  }
  @media screen and (max-width: $screen-xs) {
    width: 100%;
  }
  .imageContainer {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: $sp;
  }
  img {
    @extend .img-responsive;
    width: 100%;
  }
  a:hover {
    text-decoration: none;
  }
  a:hover .title {
    text-decoration: underline;
  }
  .titleAndCategory {
    width: 100%;
    align-self: baseline;
  }
  .text {
    margin-top: 8px;
    min-height: 9em;
    vertical-align: top;
    display: flex;
    flex-direction: column;
  }
  .title {
    text-decoration: underline;
    .priceInline {
      float: right;
    }
  }
}

.productLink {
  width: 100%;
}
.price {
  padding-left: $sp;
  font-weight: 600;
  white-space: nowrap;
}
.price.priceBelow {
  display: none;
  padding-left: 0;
  text-decoration: none;
}
@media screen and (max-width: $screen-md) {
  .price.priceInline {
    display: none;
  }
  .price.priceBelow {
    display: block;
  }
}

img {
  opacity: 0;
  transition: opacity 0.5s;
}
img.loaded {
  opacity: 1;
}
.soldout {
  color: $brand-danger;
}

.categories {
  font-weight: bold;
}
.categories span:not(:last-child):after {
  content: ', ';
}

.checkoutActions {
  padding-top: $sp;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: $sp * 0.5;
  button {
    flex-grow: 1;
  }
}
.productType {
  font-weight: bold;
  padding-bottom: $sp/4;
}
</style>
